"use client";

import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";

import { cx } from "../../cx";
import styles from "./tabs.module.css";

export type TabsListVariant = "line" | "segmented" | "solid";

type WithClassName<P> = Omit<P, "className"> & { className?: string };

function Tabs({
  className,
  orientation = "horizontal",
  ...props
}: WithClassName<TabsPrimitive.Root.Props>) {
  return (
    <TabsPrimitive.Root
      data-tui=""
      data-slot="tabs"
      orientation={orientation}
      className={cx(styles.tabs, className)}
      {...props}
    />
  );
}

function TabsList({
  className,
  variant = "line",
  activateOnFocus = true,
  children,
  ...props
}: WithClassName<TabsPrimitive.List.Props> & { variant?: TabsListVariant }) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      data-variant={variant}
      activateOnFocus={activateOnFocus}
      className={cx(styles.list, className)}
      {...props}
    >
      {children}
      <TabsPrimitive.Indicator
        data-slot="tabs-indicator"
        className={styles.indicator}
      />
    </TabsPrimitive.List>
  );
}

function TabsTrigger({
  className,
  ...props
}: WithClassName<TabsPrimitive.Tab.Props>) {
  return (
    <TabsPrimitive.Tab
      data-tui=""
      data-slot="tabs-trigger"
      className={cx(styles.trigger, className)}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: WithClassName<TabsPrimitive.Panel.Props>) {
  return (
    <TabsPrimitive.Panel
      data-slot="tabs-content"
      className={cx(styles.content, className)}
      {...props}
    />
  );
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
